import React from 'react';
import { Link } from 'react-router-dom';
import logoplk from '../../assets/logos/logo-plk.svg';

function PLKlogo() {
  return (
    <div>
      <Link to="/restaurants">
        <img src={logoplk} alt="logoplk" />
      </Link>
    </div>
  );
}

export default PLKlogo;
